<template>
  <div class="universal-card">
    <div class="header-container" :class="hasBottomBorder ? 'border-bottom' : ''">
      <div class="header-left mx-1"><slot name="header"></slot></div>
      <div class="header-right">
        <!-- 快捷日期 -->
        <div v-if="hasTime"><quickDateSelection :init-date-limit="initDateLimit" :is-show-quick-time="isShowQuickTime" @showCustomize="showCustomize" /></div>
        <!-- 参数类型 -->
        <div v-if="hasEnergy" class="energy-space">
          <div class="type-list">
            <el-radio-group v-model="frontTagValue" size="small" @change="changeFrontTag">
              <el-radio-button v-for="item in frontEnergyOptions" :key="item.label" :label="item.label" />
            </el-radio-group>
          </div>
          <div v-if="hasCascader">
            <cascader-button
              v-model="addTagValue"
              :options="typeOptions"
              :is-active="handleClick"
              :cascader-default="cascaderDefault"
              :props="{ multiple: cascaderDefault, checkStrictly: true, emitPath: false, value: 'label' }"
              :name="tagCascader"
              @cancel="addTagValue = []"
              @confirm="handleAddConfirmTag"
            />
          </div>
          <div v-else>
            <el-popover v-model="isShowMove" placement="bottom" width="400" trigger="click">
              <div v-if="moveEnergyOptions ? true : false" class="move-parameters">
                <el-scrollbar style="height:100%">
                  <ul>
                    <li
                      v-for="(item, index) in moveEnergyOptions"
                      :key="index"
                      :title="item.label + item.unit"
                      :class="{ moveTagActivity: moveTageIndex === index }"
                      @click="changeMoveIndex(item, index)"
                    >
                      {{ item.label + item.unit }}
                    </li>
                  </ul>
                </el-scrollbar>
              </div>
            </el-popover>
          </div>
        </div>
        <!-- 选择设备类型 -->
        <div v-if="hasEnergyType"><el-button type="primary" size="medium" style="margin-top: 10px;" @click="$emit('selectDeviceType', true)">{{ $t('选择类型') }}</el-button></div>
        <!-- 选择区域 -->
        <div v-if="hasArea"><el-button type="primary" size="medium" style="margin-top: 10px;" @click="$emit('selectArea', true)">{{ $t('选择区域') }}</el-button></div>
        <!-- 选择能源 -->
        <div v-if="hasSource">
          <cascader-button
            v-model="addValue"
            class="mt-1 mr-1"
            :medium-btn="mediumBtn"
            :options="typeOptions"
            :props="{ multiple: true, checkStrictly: true, emitPath: false, value: 'label' }"
            :name="$t('选择能源类型')"
            @cancel="addValue = energyTypeList || []"
            @confirm="handleAddConfirm"
          />
        </div>
        <!-- 选择区域/设备 -->
        <div v-if="hasAreaEquipment"><el-button type="primary" size="medium" style="margin-top: 10px;" @click="$emit('selectAreaEqu', true)">{{ $t('选择区域\/设备') }}</el-button></div>
      </div>
    </div>
    <div><slot name="body"></slot></div>
  </div>
</template>

<script>
/**
 * 组件：
 * <universalCard
 *  :has-time="true">
 *    可嵌入自定义templa
 * </universalCard>
*  menuArray: [{
      {id: '1', name: this.$t('整厂能耗') },
      { id: '2', name: this.$t('设备能耗') },
      { id: '3', name: this.$t('区域能耗') }
    ]
 */

export default {
  name: 'UniversalCard',
  components: {},
  props: {
    isShowQuickTime: {
      type: Boolean,
      default: true
    },
    hasBottomBorder: {
      type: Boolean,
      default: true
    },
    hasTime: {
      type: Boolean,
      default: false
    },
    hasEnergy: {
      type: Boolean,
      default: false
    },
    hasCascader: {
      type: Boolean,
      default: false
    },
    hasEnergyType: {
      type: Boolean,
      default: false
    },
    hasArea: {
      type: Boolean,
      default: false
    },
    hasSource: {
      type: Boolean,
      default: false
    },
    hasAreaEquipment: {
      type: Boolean,
      default: false
    },
    cascaderDefault: {
      type: Boolean,
      default: true
    },
    mediumBtn: {
      type: Boolean,
      default: true
    },
    selectSingleDeviceType: {
      type: String,
      default: ''
    },
    frontEnergyOptions: {
      // 前面四个能源类型切换
      type: Array,
      default() {
        return [];
      }
    },
    frontTag: {
      // 选中值
      type: String,
      default: ''
    },
    moveEnergyOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    typeOptions: {
      // 能源类型
      type: Array,
      default() {
        return [];
      }
    },
    energyTypeList: {
      // 能耗对比
      type: Array,
      default() {
        return [];
      }
    },
    // 默认选中的显示日期
    initDateLimit: {
      type: Array,
      default() {
        return [
          this.dayjs()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          this.dayjs().format('YYYY-MM-DD')
        ];
      }
    }
  },
  data() {
    return {
      isShowBtn: true,
      isShowMove: false,
      frontTagValue: '',
      moveTageIndex: 0,
      choseMoveTage: false,
      choseMoveTagName: this.$t('更多'),
      addTagValue: [],
      addValue: [],
      handleClick: false,
      tagCascader: this.$t('更多')
    };
  },
  watch: {
    frontTag(val) {
      // 选中能源类型
      var energyList = [];
      this.frontEnergyOptions.forEach(v => {
        energyList.push(v.label);
      });
      if (energyList.indexOf(val) !== -1) {
        this.tagCascader = this.$t('更多');
        this.handleClick = false;
        this.frontTagValue = val;
      } else {
        this.tagCascader = val;
        this.handleClick = true;
        this.frontTagValue = '';
      }
      this.addTagValue = [val];
    },
    frontEnergyOptions(list) { // 能源类型选择数组
      var energyList = [];
      list.forEach(v => {
        energyList.push(v.label);
      });
      if (energyList.indexOf(this.frontTag) !== -1) {
        this.tagCascader = this.$t('更多');
        this.handleClick = false;
        this.frontTagValue = this.frontTag;
      } else {
        this.tagCascader = this.frontTag;
        this.handleClick = true;
        this.frontTagValue = '';
      }
    },
    energyTypeList(val) {
      this.addValue = val;
    }
  },
  mounted() {},
  methods: {
    // 添加赋值参数
    handleAddConfirm() {
      this.$emit('choosedEnergy', this.addValue);
    },
    handleAddConfirmTag() {
      const labelList = [];
      this.frontEnergyOptions.forEach(v => {
        labelList.push(v.label);
      });
      if (!this.addTagValue) {
        this.$message.warning(this.$t('请选择能源类型'));
        return false;
      }
      if (this.addTagValue instanceof Array) {
        this.addTagValue = this.addTagValue[0];
      }
      if (this.tagCascader === this.addTagValue) {
        return false;
      }
      if (this.frontTagValue === this.addTagValue) {
        return false;
      }
      if (labelList.join(',').indexOf(this.addTagValue) !== -1) {
        this.tagCascader = this.$t('更多');
        this.handleClick = false;
        this.frontTagValue = this.addTagValue;
      } else {
        this.tagCascader = this.addTagValue;
        this.handleClick = true;
        this.frontTagValue = '';
      }
      this.$emit('choosedEnergy', this.addTagValue);
    },
    changeFrontTag(val) {
      this.handleClick = false;
      this.tagCascader = this.$t('更多');
      this.$emit('choosedEnergy', val);
    },
    changeMoveIndex(item, index) {
      this.choseMoveTage = true;
      this.isShowMove = false;
      this.moveTageIndex = index;
      this.choseMoveTagName = item.label + item.unit;
      this.$emit('choosedEnergy', item.id);
    },
    // 是否选择自定义时间
    showCustomize(val) {
      this.$emit('showChainRatio', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.universal-card {
  .header-container {
    height: 56px;
    width: 100%;
    display: flex;
    border-color: #f0f0f0;

    .header-left {
      flex-shrink: 0;
    }

    .header-right {
      display: flex;
      margin-left: auto;
      flex-shrink: 0;
      right: 20px;

      .el-form-item {
        margin-bottom: 0;
      }

      .mark {
        .el-form-item__content {
          display: flex;
        }
      }

      .time {
        .el-input {
          width: 106px;
        }
      }

      .form-float-right {
        margin-top: 15px;
      }

      .form-float_time-right {
        margin-left: 8px;
        margin-right: 4px;

        .year-range-wrapper {
          width: 256px;

          .year-range-picker {
            width: 128px;

            .el-input__inner {
              width: 128px;
            }
          }
        }

        .el-input__inner {
          width: 256px;
        }

        .singleChose {
          .el-input {
            width: 210px;
          }

          .el-input__suffix-inner {
            .el-input__icon {
              position: absolute;
              float: right;
              right: -40px;
            }
          }
        }
      }

      .energy-space {
        display: flex;

        .type-list {
          margin-top: 12px;
          height: 30px;
        }
      }

      .parameter-btn {
        color: #606266;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 32px;
        margin-top: 14px;
        margin-right: 14px;
        padding: 0;
        width: 100px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        border-radius: 2px;

        &:hover,
        &:active,
        &:focus {
          color: $main;
          border: 1px solid $main;
        }

        .parameterLabel {
          width: 56px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .tagActivity {
        color: $main;
        border: 1px solid $main;
      }

      .fast {
        margin-top: 0;
      }

      .remove-dot {
        margin-top: 24px;
      }
    }
  }
}

.move-parameters {
  .el-scrollbar__wrap {
    height: 200px;
    overflow: auto;
    overflow-x: hidden;
  }

  ul {
    list-style: none;
    float: left;
    padding: 0;
  }

  li {
    display: inline;
    float: left;
    color: #606266;
    width: 80px;
    line-height: 30px;
    margin-left: 10px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 10px;
    margin-bottom: 10px;
    border-radius: 2px;

    &:hover,
    &:active,
    &:focus {
      color: $main;
    }
  }
}

.frontTagActivity {
  color: $main !important;
  border: 1px solid $main !important;
}

.moveTagActivity {
  color: $main !important;
}
</style>
